// ── FundForm ──
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const FundForm = ({ initial, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const [f, set] = useFreshForm(initial || {
      fundname: '', startdate: '', enddate: '', status: 'Active'
    }, "Funds");
    return (
      <Modal
        title={readOnly ? 'View Fund' : initial ? 'Edit Fund' : 'Add Fund'}
        onClose={closeModal}
        onEdit={readOnly && role.canManageUsers ? () => { closeModal(); setModal({ type: 'fund-edit', rec: initial, onDone: modal.onDone }); } : null}
      >
        <ReadOnlyForm readOnly={readOnly}>
          <Field label="Fund Name"><FInput value={f.fundname || ''} onChange={set('fundname')} /></Field>
          <Field label="Start Date"><FInput type="date" value={f.startdate?.slice(0, 10) || ''} onChange={set('startdate')} /></Field>
          <Field label="End Date"><FInput type="date" value={f.enddate?.slice(0, 10) || ''} onChange={set('enddate')} /></Field>
          <Field label="Status">
            <FSelect value={f.status || 'Active'} onChange={set('status')} options={['Active', 'Closed']} />
          </Field>
        </ReadOnlyForm>
        {!readOnly && error && <div style={{ color: '#993C1D', fontSize: 12, marginBottom: 8, marginTop: 8 }}>{error}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <Btn onClick={closeModal}>{readOnly ? 'Close' : 'Cancel'}</Btn>
          {!readOnly && (
            <Btn disabled={saving} variant="primary"
              onClick={() => saveRec('saveFund', f, initial ? 'Edited' : 'Added', 'Funds',
                (initial ? 'Updated' : 'Added') + ' fund: ' + f.fundname, modal.onDone)}>
              {saving ? 'Saving...' : 'Save'}
            </Btn>
          )}
          
        </div>

      </Modal>
    );
  };
